module.exports = __webpack_public_path__ + "static/media/43.f374f178.mp3";